var _Defs, _ClipPath, _Path, _Path2, _Path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Defs, Path, ClipPath, Use } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: style */
function SvgClubDay(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    id: "clubDay_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 90 90",
    xmlSpace: "preserve"
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(Path, {
    id: "clubDay_svg__SVGID_1_",
    d: "M0 0h90v90H0z"
  }))), _ClipPath || (_ClipPath = /*#__PURE__*/React.createElement(ClipPath, {
    id: "clubDay_svg__SVGID_00000183218402972914096940000008863734230661113752_"
  }, /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#clubDay_svg__SVGID_1_",
    overflow: "visible"
  }))), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M45 90c24.9 0 45-20.1 45-45S69.9 0 45 0 0 20.1 0 45s20.1 45 45 45",
    clipPath: "url(#clubDay_svg__SVGID_00000183218402972914096940000008863734230661113752_)",
    fill: "#409d27"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M75.9 21C68.8 11.8 57.6 5.8 45 5.8 23.4 5.8 5.8 23.4 5.8 45S23.4 84.2 45 84.2c13 0 24.6-6.4 31.7-16.2l-3.5-3.2C66.9 73.7 56.6 79.5 45 79.5 26 79.5 10.5 64 10.5 45S26 10.5 45 10.5c11.3 0 21.3 5.4 27.6 13.7l3.3-3.2z",
    clipPath: "url(#clubDay_svg__SVGID_00000183218402972914096940000008863734230661113752_)",
    fill: "#fff"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "M22.8 45c0 10.8 8.9 20.1 23.4 20.1 6.5 0 10.8-1.8 14.7-4.5l-3.1-5.4c-3 2.1-7 3.6-11.6 3.6-9.7 0-15.4-6.2-15.4-13.7s5.7-13.7 15.4-13.7c4.6 0 8.6 1.6 11.6 3.6l3.1-5.3c-4-2.7-8.3-4.6-14.7-4.6-14.5-.2-23.4 9.1-23.4 19.9",
    clipPath: "url(#clubDay_svg__SVGID_00000183218402972914096940000008863734230661113752_)",
    fill: "#fff"
  })));
}
export default SvgClubDay;